function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.84626 3.25137L6.21358 2.62476L8.44596 0.413798C8.71081 0.148532 9.07191 0 9.44869 0H9.45168C9.8262 0.000738878 10.1851 0.150002 10.4485 0.413798L13.5881 3.52026C14.1364 4.06928 14.1372 4.95304 13.5911 5.50347L11.3558 7.71727L6.84626 3.25137ZM13.5409 11.1134H7.9252L10.7224 8.34539L5.58109 3.25118L0.41519 8.3645C-0.138397 8.91351 -0.138397 9.80171 0.41519 10.3507L1.94913 11.8699C2.03269 11.9527 2.14685 11.9993 2.26546 12H6.84347H6.85615H13.5411H13.5403C13.788 12 13.988 11.8012 13.988 11.5566C13.988 11.312 13.788 11.1133 13.5403 11.1133L13.5409 11.1134Z",
  fill: "currentColor"
});

var SvgEraser = function SvgEraser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEraser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eraser.9925160b.svg";
export { ForwardRef as ReactComponent };